import React, { useEffect, useState } from "react";
import styles from "./schedule-activity.module.css";
import { Typography } from "antd";
import CustomButton from "../../../../../../../common/custom-button/custom-button";
import { PlusOutlined } from "@ant-design/icons";
import CustomTable from "../../../../../../../common/custom-table/custom-table";
import SVGIcon from "../../../../../../../constants/SVGIcon";
import AddEditScheduleActivity from "./components/add-edit-schedule-activity/add-edit-schedule-activity";
import { fetchActivityClassName } from "../../../../../../../services/school_info";
import UploadCsv from "./upload-csv";
import ScheduleRoutineTable from "./components/schedule-routine-table/schedule-routine-table";

const ScheduleActivity = () => {
  const [activityClassName, setActivityClassName] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [showUploadDrawer, setShowUploadDrawer] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);

  useEffect(() => {
    setPageNo(1);
    getActivityClassNames();
  }, []);

  const getActivityClassNames = async (
    tempPage = pageNo,
    tempPageSize = pageSize
  ) => {
    try {
      setLoading(true);
      const payload = {
        page: tempPage,
        pageSize: tempPageSize,
      };
      const response = await fetchActivityClassName(payload);
      if (response?.data) {
        const data = response?.data?.data?.classrooms;
        setActivityClassName(data);
        setTotalCount(response?.data?.data?.totalRecords);
        return data;
      }
      return [];
    } catch (err) {
      console.log(err);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    getActivityClassNames(page, pageSize);
  };

  const handleOnClose = () => {
    getActivityClassNames();
    setOpenDrawer(false);
    setSelectedClass(null);
  };

  const columns = [
    {
      title: "Level Name",
      dataIndex: "level",
      key: "level",
      sorter: (a, b) => a?.level?.name?.localeCompare(b?.level?.name),
      render: (value) => value?.name || "-",
    },
    {
      title: "Classes",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      render: (value) => value || "-",
    },
    {
      title: "Action",
      key: "action_child",
      align: "center",
      render: (_, record) => (
        <div className={styles.viewRoutineWrapper}>
          <CustomButton
            title="View Routine"
            size="small"
            onClick={() => setSelectedClass(record)}
            className={styles.viewRoutineBtn}
          />
        </div>
      ),
    },
  ];

  const handleRedirectEditForm = (matchedRecord) => {
    setEditDetails(matchedRecord);
    setOpenDrawer(true);
  };

  return (
    <div>
      {selectedClass ? (
        <ScheduleRoutineTable
          classData={selectedClass}
          onBack={() => setSelectedClass(null)}
          onEdit={(record) => {
            setEditDetails(record);
            setOpenDrawer(true);
          }}
          onCreate={() => {
            setEditDetails(null);
            setOpenDrawer(true);
          }}
          handleOnClose={handleOnClose}
        />
      ) : (
        <div>
          <div className={styles.titleContainer}>
            <Typography className={styles.tabTitle}>Schedule</Typography>

            <div className={styles.rightTitleButton}>
              <CustomButton
                title="Upload Csv File"
                size="large"
                icon={
                  <SVGIcon
                    name="upload"
                    width="24"
                    height="24"
                    className="anticon"
                    stroke="#FFF"
                  />
                }
                onClick={() => setShowUploadDrawer(!showUploadDrawer)}
              />
              <CustomButton
                title="Add New Schedule and Activity"
                size="large"
                icon={<PlusOutlined />}
                onClick={() => {
                  setOpenDrawer(true);
                  setEditDetails(null);
                }}
              />
            </div>

            <UploadCsv
              open={showUploadDrawer}
              accepts=".csv"
              onClose={() => setShowUploadDrawer(false)}
              getActivityClassNames={getActivityClassNames}
              onAfterUploadSuccess={handleRedirectEditForm}
            />
          </div>

          <div className={styles.tableContainer}>
            <CustomTable
              columns={columns}
              dataSource={activityClassName}
              headerColor="#667085"
              headerBackgroundColor="#F9FAFB"
              loading={loading}
              total={totalCount}
              pageSize={pageSize}
              currentPage={pageNo}
              handlePageChange={handleChangePage}
            />
          </div>
        </div>
      )}
      <AddEditScheduleActivity
        open={openDrawer}
        onClose={handleOnClose}
        editDetails={editDetails}
        selectedClass={{
          level_id: selectedClass?.level?.id,
          classroom_id: selectedClass?.id,
        }}
      />
    </div>
  );
};

export default ScheduleActivity;
